import { EnvironmentType } from '@/react/portainer/environments/types';
import { useEnvironmentList } from '@/react/portainer/environments/queries/useEnvironmentList';

/**
 * useAddonEnvironmentId resolves the local in-cluster Kubernetes environment
 * that add-ons run on. The add-on API does not carry an environmentId, so it is
 * looked up from the environment list by type.
 */
export function useAddonEnvironmentId({ enabled = true } = {}) {
  const localEnvQuery = useEnvironmentList(
    { types: [EnvironmentType.KubernetesLocal] },
    { enabled }
  );

  return {
    environmentId: localEnvQuery.environments[0]?.Id,
    isLoading: localEnvQuery.isLoading,
  };
}
